import { render, staticRenderFns } from "./StatData.yaml?vue&type=template&id=fe9bd0a4&component"
import script from "./StatData.yaml?vue&type=script&lang=ts&component"
export * from "./StatData.yaml?vue&type=script&lang=ts&component"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports